import { useCallback } from "react";
import { setUserId, identify, Identify } from "@amplitude/analytics-browser";
import { type IUserDetails } from "@types";

export function useAmplitudeIdentify() {
  const identifyUser = useCallback((user?: IUserDetails) => {
    if (user == null) {
      return;
    }

    setUserId(String(user.id));

    const userIdentity = new Identify();
    userIdentity.set("id", user.id);

    if (user?.age != null && user.age > 0) {
      userIdentity.set("age", user.age);
    }

    if (user?.gender != null) {
      userIdentity.set("gender", user.gender);
    }

    if (user?.maritalStatus != null) {
      userIdentity.set("maritalStatus", user.maritalStatus);
    }

    identify(userIdentity);
  }, []);

  return { identifyUser };
}
